import * as React from "react";
const SvgChevron = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 16" {...props}><path d="M.75 1.713 7.22 8 .75 14.284 2.515 16l8.235-8-8.235-8z" /></svg>;
export default SvgChevron;